const NavigationAnalytics = () => null;
export default NavigationAnalytics;
